import { providers } from 'ethers';
import { useMemo } from 'react';
import type { WalletClient } from 'viem';
import { useWalletClient } from 'wagmi';

/**
 * Convert wagmi WalletClient to ethers Signer
 */
export function walletClientToSigner(client: WalletClient) {
  const { account, chain, transport } = client as any;
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  };
  const provider = new providers.Web3Provider(transport, network);
  const signer = provider.getSigner(account.address);
  return signer;
}

/**
 * Hook to convert a viem Wallet Client to an ethers.js Signer
 * This allows ethers v5 contracts to work with wagmi v2
 */
export function useEthersSigner() {
  const { data: walletClient } = useWalletClient();
  
  return useMemo(
    () => (walletClient ? walletClientToSigner(walletClient) : undefined),
    [walletClient]
  );
}
